import { buildFullAccessFor } from 'ra-auth-acl'

const permissions = {
  admin: {
    es: {
      ...buildFullAccessFor([
        'campaigns',
        'user',
        'questions',
        'responses',
        'thematics',
        'coregs',
        'wscampaigns',
        'delivery',
      ]),
    },
    fr: {
      ...buildFullAccessFor([
        'campaigns',
        'user',
        'questions',
        'responses',
        'thematics',
        'coregs',
        'wscampaigns',
        'delivery',
      ]),
    },
    it: {
      ...buildFullAccessFor([
        'campaigns',
        'user',
        'questions',
        'responses',
        'thematics',
        'coregs',
        'wscampaigns',
        'delivery',
      ]),
    },
  },
  operations: {
    es: {
      ...buildFullAccessFor([
        'campaigns',
        'user',
        'questions',
        'responses',
        'thematics',
        'coregs',
        'wscampaigns',
        'delivery',
      ]),
    },
    fr: {
      ...buildFullAccessFor([
        'campaigns',
        'user',
        'questions',
        'responses',
        'thematics',
        'coregs',
        'wscampaigns',
        'delivery',
      ]),
    },
    it: {
      ...buildFullAccessFor([
        'campaigns',
        'user',
        'questions',
        'responses',
        'thematics',
        'coregs',
        'wscampaigns',
        'delivery',
      ]),
    },
  },
  product: {
    es: {
      ...buildFullAccessFor([
        'campaigns',
        'user',
        'questions',
        'responses',
        'thematics',
        'coregs',
        'wscampaigns',
        'delivery',
      ]),
    },
    fr: {
      ...buildFullAccessFor([
        'campaigns',
        'user',
        'questions',
        'responses',
        'thematics',
        'coregs',
        'wscampaigns',
        'delivery',
      ]),
    },
    it: {
      ...buildFullAccessFor([
        'campaigns',
        'user',
        'questions',
        'responses',
        'thematics',
        'coregs',
        'wscampaigns',
        'delivery',
      ]),
    },
  },
}

export default permissions
